 $('.testimonial-slider').owlCarousel({
            loop:true,
            margin:10,
            dots:true,
            nav:false,
            items: 1,
        })
        $(document).ready(function(){
    var firstSlider = $('.testimonials');
    var secondSlider = $('.testimonials2');
    var flag = false;

    firstSlider.owlCarousel({
        loop: true,
        margin: 0,
        dots: false,
        nav: false,
        items: 5,
        center: true,
        responsive:{
          0:{
            items:3,
          },
          992:{
            items:5,
          }
        }
    });

    secondSlider.owlCarousel({
        loop: true,
        margin: 10,
        dots: true,
        nav: false,
        items: 1,
        center: true,
        animateOut: 'owl-fade-out'
    });

    firstSlider.on('changed.owl.carousel', function(event) {
        if (!flag) {
            flag = true;
            var currentIndex = event.item.index;
            secondSlider.trigger('to.owl.carousel', [currentIndex, 300, true]);
            flag = false;
        }
    });

    secondSlider.on('changed.owl.carousel', function(event) {
        if (!flag) {
            flag = true;
            var currentIndex = event.item.index;
            firstSlider.trigger('to.owl.carousel', [currentIndex, 300, true]);
            flag = false;
        }
    });
    
});